import React from 'react';

import {ExpandableModal} from 'ui-library/modals/ExpandableModal';

export interface ChemSearchModalFrameProps {
  title: string;
  showHeaderBorder?: boolean;
  onRequestClose: () => void;
  onRequestSubmit: () => void;
  children: React.ReactNode;
}

export default function ChemSearchModalFrame({
  title,
  showHeaderBorder = true,
  onRequestClose,
  onRequestSubmit,
  children,
}: ChemSearchModalFrameProps): JSX.Element {
  return (
    <ExpandableModal
      bodyPadded={false}
      enableRedesign={true}
      showHeaderBorder={showHeaderBorder}
      title={title}
      buttons={[
        {
          text: 'Search',
          submit: true,
          dataTestAttrs: {component: 'ChemSearchModal', element: 'submit'},
        },
      ]}
      onRequestClose={onRequestClose}
      onRequestSubmit={onRequestSubmit}
      expandHeight={true}
      scrollable={true}
    >
      {children}
    </ExpandableModal>
  );
}
